<template>
  <html lang="pt-br">
    <head>
      <meta name="description" content="IBCGP — soluções digitais para municípios: gestão pública, concursos e capacitação. Afiliação gratuita.">

      <component-head-style/>
    </head>

    <body class="body-wrapper" data-spy="scroll" data-target=".privacy-nav">
      <component-nav-bar/>

      <hero-section/>
      <institutional-section/>
      <solutions-section/>
      <!-- <benefits-section/> -->
      <conversion-section/>

      <fiscais-aside-section/>

      <component-footer/>

      <btn-to-top/>
    </body>

    <component-body-scripts/>
  </html>
</template>

<script>
  import Head from '../structure/Head.vue';
  import Navbar from '../structure/Navbar.vue';

  import HeroSection from './sections/HeroSection.vue';
  import InstitutionalSection from './sections/InstitutionalSection.vue';
  import SolutionsSection from './sections/SolutionsSection.vue';
  // import BenefitsSection from './sections/BenefitsSection.vue';
  import ConversionSection from './sections/ConversionSection.vue';
  import FiscaisAsideSection from './sections/FiscaisAsideSection.vue';

  import Footer from '../structure/Footer.vue';
  import BtnToTop from '../structure/BtnToTop.vue';
  import BodyScripts from '../structure/BodyScripts.vue';

  const META_DESC = 'IBCGP — soluções digitais para municípios: gestão tributária e rural, concursos, cursos e capacitação. Afiliação gratuita ao instituto.';

  function setMetaDescription (content) {
    let el = document.querySelector('meta[name="description"]');
    if (!el) {
      el = document.createElement('meta');
      el.setAttribute('name', 'description');
      document.head.appendChild(el);
    }
    el.setAttribute('content', content);
  }

  export default {
    created(){
      document.title = 'IBCGP | Soluções digitais para municípios';
    },
    mounted () {
      setMetaDescription(META_DESC);
    },
    components:{
      'component-head-style'    : Head,
      'component-nav-bar'       : Navbar,

      'hero-section'            : HeroSection,
      'institutional-section'   : InstitutionalSection,
      'solutions-section'       : SolutionsSection,
      // 'benefits-section'        : BenefitsSection,
      'conversion-section'      : ConversionSection,
      'fiscais-aside-section'     : FiscaisAsideSection,

      'component-footer'        : Footer,
      'btn-to-top'              : BtnToTop,
      'component-body-scripts'  : BodyScripts
    },
  }
</script>
